import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-persistent-error',
  templateUrl: './persistent-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class PersistentErrorComponent {
  @Input() title;
  @Input() body;
  @Input() reason;
}
